import type { TasField } from './tas-field.type.ts';
export interface TasFieldExtension extends TasField {}
export class TasFieldExtension {
  // Computed property to get the first value (for single-value fields)
  get value(): string | null {
    return this.values?.[0] || null;
  }

  // Computed property to check if field has a value
  get hasValue(): boolean {
    return this.values !== null && this.values.length > 0;
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-field',
  features: TasFieldExtension,
};
export default Registration;
